<script>
  import { AlertTriangle } from '../lib/icons/index.js';
  import { t } from '../i18n/index.js';

  /**
   * The money the document will declare: one row per DatiRiepilogo block and
   * the total under them.
   *
   * Shared by the creation screen and by the correction form, for the reason
   * lib/totals.js exists at all — the preview an operator approves and the
   * figures that leave have to be the same arithmetic. `totals` is always the
   * result of computeInvoiceTotals(); nothing is added up here.
   */
  export let totals = { groups: [], totaleText: '0.00' };
  /** Validation issues about the total, printed under it. */
  export let issues = [];
  /** Optional sentence explaining where the total comes from. */
  export let note = '';
</script>

<div class="border-t-w pt-4 mt-4" style="border-color: var(--color-tint-medium);">
  <div class="space-y-1">
    {#each totals.groups as group}
      <div class="flex justify-between text-sm font-mono">
        <span style="color: var(--color-text-muted);">{$t('invoiceCreate.summary.taxable', { rate: group.aliquota })}</span>
        <span style="color: var(--color-text-body);">{group.imponibileText} &euro;</span>
      </div>
      <div class="flex justify-between text-sm font-mono">
        <span style="color: var(--color-text-muted);">{$t('invoiceCreate.summary.vat', { rate: group.aliquota })}</span>
        <span style="color: var(--color-text-body);">{group.impostaText} &euro;</span>
      </div>
    {/each}
  </div>
  <div class="flex justify-between text-lg font-bold font-mono border-t-w pt-2 mt-2" style="border-color: var(--color-tint-medium);">
    <span style="color: var(--color-text-heading);">{$t('invoiceCreate.summary.total')}</span>
    <span class="text-action">{totals.totaleText} &euro;</span>
  </div>
  {#if totals.pagabileText && totals.pagabileText !== totals.totaleText}
    <div class="flex justify-between text-sm font-mono mt-2">
      <span style="color: var(--color-text-heading);">{$t('invoiceCreate.summary.payable')}</span>
      <span class="text-action">{totals.pagabileText} &euro;</span>
    </div>
    <p class="mt-1 text-xs measure" style="color: var(--color-text-muted);">
      {$t('invoiceCreate.summary.payableHint', { imposta: totals.impostaScissioneText })}
    </p>
  {/if}

  {#if note}
    <p class="mt-2 text-xs measure" style="color: var(--color-text-muted);">{note}</p>
  {/if}

  {#each issues as issue}
    <p class="mt-2 flex gap-2 text-xs measure text-warning" role="status">
      <AlertTriangle size={14} class="flex-shrink-0 mt-0.5" />
      <span>{issue}</span>
    </p>
  {/each}
</div>
